module.exports = __webpack_public_path__ + "static/media/reglages-cercle.d12b3ce2.png";